import { Box, Button, TextField, Tooltip, Typography } from '@mui/material'
import { compose, always, andThen, F, pipe, T } from 'ramda'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useState } from 'react'
import { ClearIcon } from '@mui/x-date-pickers'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import CheckIcon from '@mui/icons-material/Check'
import noop from 'src/utilities/noop'
import { EditIcon } from 'src/v3/core/icons'
import { processImageFile, uploadImageToS3 } from 'src/v3/utilities/s3'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  fetchLinkedServices,
} from '../admin.slice'

export default () => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )
  let [editingName, setEditingName] = useState<boolean>(false)
  let [newName, setNewName] = useState<string>('')

  let onImageUpload = (id: string, t: any) =>
    axios
      .put('/api/v2/admin/linked-service/image', { id })
      .then((response) => uploadImageToS3(t, response.data))
      .then(() => dispatch(fetchLinkedServices()))

  let onLinkedServiceNameChanged = () => {
    if (newName) {
      return axios
        .put('/api/v2/admin/linked-service/name', {
          id: selectedLinkedService,
          name: newName,
        })
        .then(() => {
          dispatch(fetchLinkedServices())
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
        })
    }
    return Promise.resolve()
  }

  return (
    <Box>
      <img src={linkedService?.imageName} width={'100%'} />
      <div className="flex flex-row-reverse">
        <Tooltip title="Upload Thumbnail" sx={{ mt: 2 }}>
          <Button variant="outlined" component="label">
            <AddPhotoAlternateIcon onClick={noop} />
            <input
              type="file"
              accept=".jpg,.jpeg,.png"
              hidden
              onChange={(event) =>
                processImageFile(event, {
                  onLoadingStart: noop,
                  onLoadingEnd: (t: any) => {
                    onImageUpload(selectedLinkedService, t)
                  },
                })
              }
            />
          </Button>
        </Tooltip>
      </div>
      {editingName ? (
        <div className="flex items-center mt-4">
          <TextField
            label="New name"
            fullWidth
            variant="outlined"
            onChange={(e) => setNewName(e.target.value)}
          />{' '}
          <ClearIcon
            sx={{ cursor: 'pointer', mx: 1 }}
            color="error"
            onClick={pipe(
              compose(setNewName, always('')),
              compose(setEditingName, F),
            )}
          />{' '}
          <CheckIcon
            color="success"
            sx={{ cursor: 'pointer' }}
            onClick={pipe(
              onLinkedServiceNameChanged,
              andThen(compose(setEditingName, F)),
            )}
          />
        </div>
      ) : (
        <Typography variant="h6" align="center" sx={{ mt: 2 }}>
          {linkedService?.name}{' '}
          <Button variant="text" size="small">
            <EditIcon onClick={compose(setEditingName, T)} />
          </Button>
        </Typography>
      )}
    </Box>
  )
}
